import React from 'react'

export function IcRoundPlus(props) {
  return (
    <svg className='icons-style' width="1.5em" height="1.5em" viewBox="0 0 24 24" style={{ background : "rgba(0,0,0,0.1)"}} {...props}><path fill="currentColor" d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2z"></path></svg>
  )
}
export default IcRoundPlus